import { useEffect, useRef } from "react";
import { useGlobalToast } from "@/hooks/useGlobalToast";
import type { ApiErrorType } from "@/utils/apiErrorType";

export const STALE_INITIAL_LOAD_MESSAGE =
  "最新データの取得に失敗しました。表示中のデータは最新ではない可能性があります。";

export const shouldShowInitialLoadError = (
  errorType: ApiErrorType | null | undefined,
  hasCachedData: boolean,
) =>
  Boolean(
    errorType &&
      (errorType === "notFound" || errorType === "forbidden" || !hasCachedData),
  );

export const shouldKeepCachedDataOnInitialLoadError = (
  errorType: ApiErrorType | null | undefined,
  hasCachedData: boolean,
) =>
  Boolean(
    errorType &&
      errorType !== "notFound" &&
      errorType !== "forbidden" &&
      hasCachedData,
  );

export const useStaleInitialLoadErrorToast = ({
  errorType,
  hasCachedData,
  dedupeKey = "",
  message = STALE_INITIAL_LOAD_MESSAGE,
}: {
  errorType: ApiErrorType | null | undefined;
  hasCachedData: boolean;
  dedupeKey?: string;
  message?: string;
}) => {
  const { showToast } = useGlobalToast();
  const shownKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!shouldKeepCachedDataOnInitialLoadError(errorType, hasCachedData)) {
      if (!errorType) shownKeyRef.current = null;
      return;
    }

    const key = `${dedupeKey}:${errorType}`;
    if (shownKeyRef.current === key) return;
    shownKeyRef.current = key;

    showToast({
      type: "error",
      message,
    });
  }, [dedupeKey, errorType, hasCachedData, message, showToast]);
};
